import { createContext, useContext } from 'react';

interface VisualizerContextValue {
  /** The title of the visualizer. */
  title: string;
  /** Whether the visualizer is currently open or not. */
  open: boolean;
  /** Opens the visualizer. */
  onOpen(): void;
  /** Closes the visualizer. */
  onClose(): void;
}

const VisualizerContext = createContext<VisualizerContextValue>(null);
export const VisualizerProvider = VisualizerContext.Provider;
export const useVisualizerContext = () => useContext(VisualizerContext);
